import clsx from "clsx";
import PropTypes from "prop-types";

const IconDropdown = ({
  icon: Icon,
  link,
  onClick,
  isOpen = false,
  rotateOnOpen = false,
  disabled = false,
  className = "",
}) => {
  const handleClick = (e) => {
    if (disabled) return;
    if (onClick) onClick(e);
    if (link) window.location.href = link;
  };

  return (
    <div
      className={clsx(
        "flex items-center justify-center transition ease-in-out duration-300 w-8 h-8 p-2 rounded-full",
        {
          "cursor-pointer hover:bg-blue-100": !disabled && !isOpen,
          "cursor-pointer bg-blue-100": isOpen && !disabled,
          "opacity-40 cursor-not-allowed pointer-events-none": disabled,
        },
        className
      )}
      onClick={handleClick}
    >
      <Icon
        size={17}
        className={clsx(
          "transition-transform duration-300",
          rotateOnOpen && isOpen ? "rotate-180" : "rotate-0"
        )}
      />
    </div>
  );
};

IconDropdown.propTypes = {
  icon: PropTypes.elementType.isRequired,
  link: PropTypes.string,
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  rotateOnOpen: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default IconDropdown;
